import "./WishListItem.css";
import { AiOutlineClose } from "react-icons/ai";
import { AuthContext } from "../../context/AuthContext";
import { useParams, useNavigate } from "react-router-dom";
import ItemModal from "../post/ItemModal";
import { useSession } from "../../context/SessionTracker";
import React, { useEffect, useState, useContext } from "react";

export default function wishListItem({ item, removeItem, setShowTopbar, setIsAccountBalanceModalOpen }) {
  const [selectedItem, setSelectedItem] = useState();
  const [showModal, setShowModal] = useState(false);
  const [isPurchased, setIsPurchased] = useState(item.purchased);
  const [CTAFunction, setCTAFunction] = useState();
  const [totalCost, setTotalCost] = useState('');
  const [CTAButton, setCTAButton] = useState();
  const [toPurchase, setToPurchase] = useState();
  const [conversationId, setConversationId] = useState();
  const activeWishlistUsername = useParams();
  const {user} = useContext(AuthContext)
  const { trackEvent } = useSession();
  const navigate = useNavigate();

  useEffect(() => {
    console.log("wishlist item: ", item);
    // setting toPurchase state for wishlistItem
    // passed down to determine if click is toPurchase the item
    if (activeWishlistUsername.username != user.username && item.purchased === false){
      setToPurchase(true);
      setCTAButton("Purchase");
    } else {
      setToPurchase(false);
      setCTAButton("Close");
    }
  },[]);

  useEffect(() => {
    const itemPrice = parseFloat(item.price);
    if (item.shippingPrice === "Calculated" || item.ShippingPrice) {
      setTotalCost(`${itemPrice} + shipping`); 
      // Fixed shipping cost
    } else {
        const itemShipping = parseFloat(item.shippingPrice);
        const itemPricePlusShipping = itemPrice + itemShipping;
        const roundedTotalCost = itemPricePlusShipping.toFixed(2);
        setTotalCost(`${roundedTotalCost}`);
      }
    }, [item]);

  const clickItem = (item) => {
      setSelectedItem(item);
      setShowModal(true);
  };

  const closeModal = () => {
    setSelectedItem(null);
    setShowModal(false);
  };

  useEffect(() => {
    if (toPurchase === true) {
      setCTAFunction("Purchase");
    } else if (toPurchase === false) {
      setCTAFunction("Close");
    }
  }, [toPurchase]);

  const handlePurchaseSuccess = () => {
    trackEvent("wishlistTransaction", item);
    setIsPurchased(true);
    setCTAFunction("Close");
    setToPurchase(false);
    setCTAButton("Close");
  };

  useEffect(() => {
    if(conversationId){
      navigate(`/messages/${conversationId}`)
    }
  }, [conversationId])

  return (
    <div
      onClick={() => {
        clickItem(item);
      }}
      className="wish-list-item-container"
    >
      <div className="wish-list-item-details">
        <div className="image-container">
          <img src={item.imageUrl} alt="wishlist item" />
        </div>

        <div className="title-and-progress-container">
          <div className="wish-list-title-container">
            <h2 className={`wish-list-item-title ${isPurchased ? 'purchased' : ''}`}>
              {item.name}
            </h2>
            {user.username === activeWishlistUsername.username && 
              <div className="wish-item-close-icon-container">
                <AiOutlineClose className="close-wishlist-icon" onClick={() => removeItem(item)} />
              </div>
            }
          </div>
          <div className="price-container">
            {isPurchased ? (
              <h3 className={`${isPurchased ? 'purchased' : ''}`}>Purchased</h3>
            ) : (
              <h3 className="total-cost">${totalCost}</h3>
            )}
          </div>
        </div>
      </div>
      <div className="line-break" />
      {showModal && selectedItem && (
        <ItemModal
          className="item-modal-in-list"
          item={selectedItem}
          showModal={showModal}
          setShowModal={setShowModal}
          closeModal={closeModal}
          toPurchase={toPurchase}
          CTAButton={CTAButton}
          CTAFunction={CTAFunction}
          onPurchaseSuccess={handlePurchaseSuccess}
          setConversationId={setConversationId}
          setShowTopbar={setShowTopbar}
          setIsAccountBalanceModalOpen={setIsAccountBalanceModalOpen}
        />
      )}
    </div>
  );
}